<template>
	<transition name="lock-fade">
		<div class="lock-screen" v-if="configStore.locked">
			<div class="lock-panel">
				<div class="lock-avatar">
					<head-image :name="userStore.userInfo.nickName" :size="72"
						:url="userStore.userInfo.headImageThumb"></head-image>
				</div>
				<div class="lock-name">{{ userStore.userInfo.nickName }}</div>
				<div class="lock-tip">
					<i class="el-icon-lock"></i> 已锁屏，请输入锁屏密码解锁
				</div>
				<el-input class="lock-input" type="password" v-model="password" placeholder="锁屏密码" size="medium"
					show-password @keyup.enter.native="onUnlock" ref="pwdInput"></el-input>
				<div class="lock-error" v-show="error">{{ error }}</div>
				<el-button class="lock-btn" type="primary" @click="onUnlock" :loading="loading">解 锁</el-button>
				<div class="lock-exit" @click="onExit">忘记密码？退出登录</div>
			</div>
		</div>
	</transition>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import { verifyLockPassword } from '../../api/lock.js';

export default {
	name: 'lockScreen',
	components: { HeadImage },
	data() {
		return {
			password: '',
			error: '',
			loading: false
		}
	},
	methods: {
		async onUnlock() {
			if (!this.password) {
				this.error = '请输入锁屏密码';
				return;
			}
			this.loading = true;
			try {
				const ok = await verifyLockPassword(this.userStore.userInfo.id, this.password);
				if (ok) {
					this.password = '';
					this.error = '';
					this.configStore.setLocked(false);
				} else {
					this.error = '锁屏密码不正确';
				}
			} finally {
				this.loading = false;
			}
		},
		onExit() {
			this.$emit('exit');
		}
	},
	watch: {
		'configStore.locked'(locked) {
			if (locked) {
				this.password = '';
				this.error = '';
				this.$nextTick(() => {
					this.$refs.pwdInput && this.$refs.pwdInput.focus();
				});
			}
		}
	}
}
</script>

<style scoped lang="scss">
.lock-screen {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
	background: linear-gradient(135deg, #1f2233 0%, #12131c 100%);
	backdrop-filter: blur(6px);

	.lock-panel {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 40px;
		border-radius: 16px;
		background: rgba(255, 255, 255, 0.06);
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
		width: 300px;

		.lock-avatar {
			:deep(.head-image) {
				border: 3px solid rgba(255, 255, 255, 0.2);
				border-radius: 50%;
			}
		}

		.lock-name {
			margin-top: 16px;
			font-size: 18px;
			font-weight: 600;
			color: #fff;
		}

		.lock-tip {
			margin-top: 10px;
			font-size: 13px;
			color: rgba(255, 255, 255, 0.6);
		}

		.lock-input {
			margin-top: 24px;
		}

		.lock-error {
			margin-top: 8px;
			font-size: 12px;
			color: #ff6b6b;
			align-self: flex-start;
		}

		.lock-btn {
			margin-top: 18px;
			width: 100%;
		}

		.lock-exit {
			margin-top: 16px;
			font-size: 12px;
			color: rgba(255, 255, 255, 0.5);
			cursor: pointer;

			&:hover {
				color: rgba(255, 255, 255, 0.8);
			}
		}
	}
}

.lock-fade-enter-active,
.lock-fade-leave-active {
	transition: opacity 0.25s;
}

.lock-fade-enter,
.lock-fade-leave-to {
	opacity: 0;
}
</style>
